import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import "./src/floatingContactB.css"

import { useStore } from "../../app/stores/store";
import ContactModalForm from '../Modals/ContactModalForm';

export const FloatingContact = () => {

    const { userStore: { user } } = useStore();
    const [ modalShow, setModalShow ] = useState(false);

    const usrnombre: string | undefined = user?.displayName;
    const usrucorreo: string | undefined = user?.email;

  return (

    <>
        <div className='floating-contact-button' >
            <Button 
                circular
                color='facebook' 
                icon='at'
                onClick={ () => setModalShow(true) } 
            />
        </div>

        <ContactModalForm
            onHide={ () => { setModalShow(false) } }
            show={ modalShow }
            cnombre={ usrnombre }
            ccorreo={ usrucorreo }
        />
    
    </>

  )
}
